import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { getRedirectPath } from '../utils/userRole';
import { db } from '../firebase';

/**
 * Composant de redirection intelligente qui détermine la route appropriée
 * selon le type d'utilisateur (client ou employé)
 */
function UserRedirect({ user }) {
  const [redirectPath, setRedirectPath] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const determineRedirect = async () => {
      setIsLoading(true);
      try {
        if (user) {
          const path = await getRedirectPath(db, user);
          setRedirectPath(path);
        } else {
          setRedirectPath('/');
        }
      } catch (error) {
        console.error('Erreur lors de la détermination de la redirection:', error);
        setRedirectPath('/');
      } finally {
        setIsLoading(false);
      }
    };

    determineRedirect();
  }, [user]);

  // Afficher un loader pendant la détermination de la redirection
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Redirection en cours...</p>
        </div>
      </div>
    );
  }

  // Rediriger une fois le chemin déterminé
  return <Navigate to={redirectPath || '/'} replace />;
}

export default UserRedirect;
